 <!-- Account Closure request or closure request cancel or reactivation request dialog confirmation alert start -->
 <div class="modal fade" id="notification" role="dialog">
    <div class="modal-dialog modal-lg notificationdiv">
      <div class="modal-content notification-modal" style="border-width: none;">
        <div class="modal-body" style="position:relative">
          <div class="message-content">
            <div><span><img src="../../../../../../../assets/images/New_Icons/alert-danger-without-fill.svg" width="50px" height="50px" alt="Danger icon"></span></div>
            <div>
              <span class="notification-main-messsage">{{message}}</span><br>
              <span class="notification-sub-messsage">{{subMessage}}</span>
            </div>
          </div>
          <div style="text-align: right;margin-top: 3rem;">
            <button class="modal-btn registerbtn" (click)="submitBtnName == 'Close' ? onSubmittingTheRequest() : onCancelingTheRequest()" [disabled]="requestBtnEnableDisable">{{submitBtnName}}</button>
            <button class="modal-btn skipbtn" (click)="cancelBthName == 'Cancel' ? onCancelingTheRequest() : onSubmittingTheRequest()" [disabled]="cancelBtnEnableDisable">{{cancelBthName}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Account Closure request or closure request cancel or reactivation request dialog confirmation alert end -->
  
  <!-- Account Closure request or closure request cancel or reactivation request dialog sucessfull alert start -->
  <div class="modal fade" id="sucessNotification" role="dialog">
    <div class="modal-dialog modal-lg notificationdiv">
      <div class="modal-content notification-modal" style="border-width: none;">
        <div class="modal-body" style="position:relative">
          <div class="sucessfull-message-content">
            <div>
              <span><img src="../../../../../../../assets/images/New_Icons/approve icon.svg" width="40px" height="40px" alt="Approve icon"></span>
            </div>
            <div>
              <span class="sucess-messsage">{{sucessMessage}}</span><br>
              <span class="sucess-messsage">{{sucessSubMessage}}</span>
            </div>
          </div>
          <div style="text-align: center;margin-top: 3rem;">
            <button class="modal-btn skipbtn" (click)="onCloseSucessfullPopup()">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Account Closure request or closure request cancel or reactivation request dialog sucessfull alert end -->

  <!-- Account Closure request or closure request cancel or reactivation request dialog sucessfull alert start -->
  <div class="modal fade" id="browserReloadConfirmation" role="dialog">
    <div class="modal-dialog modal-lg notificationdiv">
      <div class="modal-content notification-modal" style="border-width: none;">
        <div class="modal-body" style="position:relative">
          <div class="sucessfull-message-content">
            <div>
              <span class="sucess-messsage">Changes you made may not be saved.</span>
            </div>
          </div>
          <div style="text-align: right;margin-top: 15px;">
            <button class="modal-btn skipbtn">Relaod</button>
            <button class="modal-btn registerbtn">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Account Closure request or closure request cancel or reactivation request dialog sucessfull alert end -->
